import React from 'react'
import {App} from 'src/layouts'
import {NextPageContext} from "next";
import {Channel as ChannelType, Request} from "eyecons-requests";
import {ChannelHero, ChannelEvents, ChannelVideos} from "src/components";
import Head from "next/head";

type ChannelProps = {
    channel: ChannelType
}

export default function Channel ({channel}: ChannelProps) {
    return (
        <>
            <Head>
                <title>{channel.label} - Eyecons</title>
                <meta name="apple-itunes-app" content={`app-id=6451410028, app-argument=eyecons://ChannelScreen/id/${channel.id}`} />

                <meta name={'twitter:card'} content={'summary_large_image'}/>
                <meta name={'twitter:image'} content={channel.logo}/>
                <meta name={'twitter:title'} content={channel.label + ' - Eyecons'}/>

                <meta property={'og:type'} content={'profile'}/>
                <meta property={'og:title'} content={channel.label + ' - Eyecons'}/>
                <meta property={'og:image'} itemProp={'image'} content={channel.logo}/>
            </Head>
            <ChannelHero channel={channel}/>
            <ChannelEvents channel={channel}/>
            <ChannelVideos channel={channel}/>
        </>
    )
}

Channel.getLayout = function getLayout(page: React.ReactElement) {
    return (
        <App>{page}</App>
    )
}

export const getServerSideProps = async (ctx: NextPageContext) => {
    const slug = ctx.query.slug

    const channels = await Request.fromApi('backend', {public: true}).get(`/channels`, {
        name: slug,
        details: true,
        clubs: true,
        teams: true,
    })

    if (!channels.data.length) {
        return {
            notFound: true
        }
    }

    return {
        props: {
            channel: channels.data[0]
        }
    }
}
